<template>
  <div>
    <Form :model="setting" :label-width="200" inline>
      <FormItem label="是否开启苏州积分抵扣配置">
        <i-switch
          v-model="setting.enable_suzhou_points"
          size="large"
          @on-change="change('enable_suzhou_points')"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>

      <br />
      <FormItem
        label="积分抵扣比列（0-100）%"
        v-if="setting.enable_suzhou_points"
      >
        <Input
          style="width: 500px"
          type="number"
          placeholder="请输入积分抵扣比列（0-100）%"
          v-model="setting.suzhou_points_percentage"
          @on-blur="change('suzhou_points_percentage')"
        />
      </FormItem>

      <br />
      <FormItem label="设备SN" v-if="setting.enable_suzhou_points">
        <Input
          style="width: 500px"
          type="text"
          placeholder="请输入设备SN"
          v-model="setting.suzhou_points_sn"
          @on-blur="change('suzhou_points_sn')"
        />
      </FormItem>

      <br />
      <FormItem label="志愿者系统域名" v-if="setting.enable_suzhou_points">
        <Input
          style="width: 500px"
          type="text"
          placeholder="请输入志愿者系统域名"
          v-model="setting.suzhou_points_host"
          @on-blur="change('suzhou_points_host')"
        />
      </FormItem>
    </Form>
  </div>
</template>

<script>
import i18n from "../../locales/index";

import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      switch1: false,
    };
  },
  created() {
    this.display();
  },
  computed: {
    ...mapGetters("setting", ["setting"]),
  },
  methods: {
    ...mapActions("setting", ["display", "upgrade"]),
    change(key) {
      this.upgrade({ [key]: this.setting[key] });
    },
  },
};
</script>
